import { SnackbarConstants } from '../constants/snackbar.constants';

const initialState = {
    snackbarOpen: false,
    snackbarType: "success",
    snackbarMessage: "",
    snackbarVertical : "top",
    snackbarHorizontal :  "center"
};

export function setSnackbar (state = initialState, action) {
    switch (action.type) {
        case SnackbarConstants.Set_SNACKBAR:
            
            const { snackbarOpen, snackbarType, snackbarMessage, snackbarVertical, snackbarHorizontal } = action;
            return {
                ...state,
                snackbarOpen,
                snackbarType,
                snackbarMessage,
                snackbarVertical,
                snackbarHorizontal
            };
        default:
            return state;
    }
};